export var mainAxisSideLookup = {
  top: 'start',
  right: 'end',
  bottom: 'end',
  left: 'start'
};